import { RemExpertResultatSalarie } from "components/app/Api/ResultatRemExpertSalarieProvider";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { ApplySignedFormat } from "components/app/ApplySignedFormat";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import ContratFacProModal from "pages/audit complet/simulation/contratfacultatifpro pager";
import React, { useContext, useState } from "react";
import { FaGlobe, FaBuilding, FaUser, FaFileInvoiceDollar, FaFileContract, FaMoneyBillWave, FaUserTie, FaHandHoldingUsd } from "react-icons/fa";
import { CompactFinancialOptiRem } from "components/app/AuditRemuneration/Resultat/CompactFinancialCard";

function OptimisationRemunerationSalarie(props) {
  let { Prenom, ClientConjoint } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const ResultatSalarie = useContext(RemExpertResultatSalarie);
  let CliConj = ClientConjoint === "" ? "" : "Conjoint";
  let CliConjRai = (ClientConjoint === ""  ||ClientConjoint === "ConjointAssocie" )? "" : "Conjoint";
  const [modalContrat, setModalContrat] = useState(false);
  const [modalDetailSalarie, setModalDetailSalarie] = useState(false);

  let CoutRemSituationOrigine = 0;
  let CotisationsSituationOrigine = 0;
  let RemNetteSituationOrigine = 0;
  let RemImposableSituationOrigine = 0;
  let StatutOrigine = "";
  let StatutNouvelle = "";
  if (ClientConjoint === "ConjointAssocie") {
    StatutOrigine = context.state.PeriodeActuelle[0]?.StatutConjoint;
    StatutNouvelle = context.state["OptiRemPeriodeActuelle"]!==undefined ?context.state.OptiRemPeriodeActuelle[0]?.StatutConjoint:"";
    if (context.state.PeriodeActuelle[0]?.StatutConjoint === "TNS Article 62" || context.state.PeriodeActuelle[0]?.StatutConjoint === "TNS individuel") {
      const Resultat = ResultatTNS.state.RemunerationTNSConjoint;
      CoutRemSituationOrigine = Resultat.CoutRemuneration;
      CotisationsSituationOrigine = Number(Resultat.TotalChargesSociales) + Number(Resultat.CotisationsFacultativesEntreprise);
      RemNetteSituationOrigine = Resultat.RemunerationNette;
      RemImposableSituationOrigine = Resultat.BrutImposable;
    } else {
      const Resultat = ResultatSalarie.state.RemunerationSalarieConjoint;
      CoutRemSituationOrigine = Resultat.CoutRemuneration;
      CotisationsSituationOrigine = Number(Resultat.TotalChargesPatronale) + Number(Resultat.TotalChargesSalariale);
      RemNetteSituationOrigine = Resultat.SalaireNet;
      RemImposableSituationOrigine = Resultat.BrutImposable;
    }
  } else {
    StatutOrigine = context.state["PeriodeActuelle" + ClientConjoint][0]?.Statut;
    StatutNouvelle = context.state["OptiRemPeriodeActuelle" + ClientConjoint] !== undefined ? context.state["OptiRemPeriodeActuelle" + ClientConjoint][0]?.Statut : "";
    if (context.state["PeriodeActuelle" + ClientConjoint][0]?.Statut === "TNS Article 62" || context.state["PeriodeActuelle" + ClientConjoint][0]?.Statut === "TNS individuel") {
      const Resultat = ResultatTNS.state["RemunerationTNS" + ClientConjoint];
      CoutRemSituationOrigine = Resultat.CoutRemuneration;
      CotisationsSituationOrigine = Number(Resultat.TotalChargesSociales) + Number(Resultat.CotisationsFacultativesEntreprise);
      RemNetteSituationOrigine = Resultat.RemunerationNette;
      RemImposableSituationOrigine = Resultat.BrutImposable;
    } else {
      const Resultat = ResultatSalarie.state["RemunerationSalarie" + ClientConjoint];
      CoutRemSituationOrigine = Resultat.CoutRemuneration;
      CotisationsSituationOrigine = Number(Resultat.TotalChargesPatronale) + Number(Resultat.TotalChargesSalariale);
      RemNetteSituationOrigine = Resultat.SalaireNet;
      RemImposableSituationOrigine = Resultat.BrutImposable;
    }
  }
  return (
    <CardBox className="blockRoundedForce" bpad>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%" }}>

        <CompactFinancialOptiRem
          icon={<FaBuilding />}
          title="Statut social"
          valueOrigine={StatutOrigine}
          valueNouvelle={StatutNouvelle}
          valueEcart={""}
          accentColor="#2563eb"
        />
        <CompactFinancialOptiRem
          icon={<FaUser />}
          title={`Budget rémunération pour ${Prenom}`}
          valueOrigine={applyFormat(CoutRemSituationOrigine, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemCoutRemuneration" + CliConj]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("cout_remuneration", "OptiRemCoutRemuneration" + CliConj, ClientConjoint, ResultatTNS, false, e);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemCoutRemuneration" + CliConj]) - Number(CoutRemSituationOrigine))}
          accentColor="#059669"
        />
        <CompactFinancialOptiRem
          icon={<FaFileContract />}
          title="Cotisations obligatoires et facultatives"
          valueOrigine={applyFormat(CotisationsSituationOrigine, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(context.state["OptiRemCotisations" + CliConj], "uint", { thousands: " ", decimal: ",", unit: " €" })}
          onEdit={() => {
            setModalContrat(true);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemCotisations" + CliConj]) - Number(CotisationsSituationOrigine))}
          accentColor="#dc2626"
        />
        <CompactFinancialOptiRem
          icon={<FaMoneyBillWave />}
          title="Rémunération nette"
          valueOrigine={applyFormat(RemNetteSituationOrigine, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemRemNette" + CliConj]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("salaire_net", "OptiRemRemNette" + CliConj, ClientConjoint, ResultatTNS, false, e);
          }}
          onEdit={() => {
            setModalDetailSalarie(true);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemRemNette" + CliConj]) - Number(RemNetteSituationOrigine))}
          accentColor="#2563eb"
        />
        <CompactFinancialOptiRem
          icon={<FaFileInvoiceDollar />}
          title="Rémunération imposable"
          valueOrigine={applyFormat(RemImposableSituationOrigine, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemRemImposable" + CliConj]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("brut_imposable", "OptiRemRemImposable" + CliConj, ClientConjoint, ResultatTNS, false, e);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemRemImposable" + CliConj]) - Number(RemImposableSituationOrigine))}
          accentColor="#2563eb"
        />
      </div>
        <Modal
          width="80%"
          height="80%"
          title="Situation professionnelle"
          icon={<FaGlobe />}
          visible={modalContrat}
          onClose={() => {
            context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs" + CliConjRai, CliConjRai, ResultatTNS,false, context.state["OptiRemResAvtIs" + CliConjRai]);
            setModalContrat(false);
          }}
        >
          <ContratFacProModal
            Outil="OptiRem"
            ClientConjoint={CliConj}
            visible={modalContrat}
            onClose={() => {
              context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs" + CliConjRai, CliConjRai, ResultatTNS,false, context.state["OptiRemResAvtIs" + CliConjRai]);
              setModalContrat(false);
            }}
          />
        </Modal>

        <Modal
          width="615px"
          height="370px"
          title="Optimisation de l'existant"
          icon={<FaGlobe />}
          visible={modalDetailSalarie}
          onClose={() => {
            setModalDetailSalarie(false);
          }}
        >
          <Column center fill>
            <CardBox>
              <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%" }}>
                <CompactFinancialOptiRem
                  icon={<FaBuilding />}
                  title="Cotisations patronales"
                  valueNouvelle={applyFormat(context.state["OptiRemCotisationsPatronale" + CliConj], "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  accentColor="#dc2626"
                  hideOrigine={true}
                />
                <CompactFinancialOptiRem
                  icon={<FaMoneyBillWave />}
                  title="Salaire brut"
                  valueNouvelle={context.state["OptiRemRemBrute" + CliConj]}
                  isEditable={true}
                  onChange={(e) => {
                    context.handleCalculOptiRem("salaire_brut", "OptiRemRemBrute" + CliConj, ClientConjoint, ResultatTNS, false, e);
                  }}
                  accentColor="#ea580c"
                  hideOrigine={true}
                />
                <CompactFinancialOptiRem
                  icon={<FaUserTie />}
                  title="Cotisations salariales"
                  valueNouvelle={applyFormat(context.state["OptiRemCotisationsSalariale" + CliConj], "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  accentColor="#ea580c"
                  hideOrigine={true}
                />
                <CompactFinancialOptiRem
                  icon={<FaHandHoldingUsd />}
                  title="Salaire net"
                  valueNouvelle={context.state["OptiRemRemNette" + CliConj]}
                  isEditable={true}
                  onChange={(e) => {
                    context.handleCalculOptiRem("salaire_net", "OptiRemRemNette" + CliConj, ClientConjoint, ResultatTNS, false, e);
                  }}
                  accentColor="#2563eb"
                  hideOrigine={true}
                />
              </div>
            </CardBox>
          </Column>
        </Modal>
      </CardBox>
    );
}
export default OptimisationRemunerationSalarie;
